import { JsonObject, JsonProperty } from 'json2typescript';
import * as uuid from 'uuid';

import { FundTransferInterface } from '../../../core';
import { Id } from './id';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('FundTransfer')
export class FundTransfer implements FundTransferInterface {
    private readonly _id: Id = undefined;

    @JsonProperty('ExternalTransfer_FundManager', StringAdapter, true)
    private _externalTransferManager: string = undefined;
    private _externalTransferManagerName: string = undefined;

    @JsonProperty('ExternalTransfer_FundName', StringAdapter, true)
    private _externalTransferName: string = undefined;

    @JsonProperty('ExternalTransfer_ISIN', StringAdapter, true)
    private _externalTransferISIN: string = undefined;

    @JsonProperty('ExternalTransfer_Contract', StringAdapter, true)
    private _externalTransferContract: string = undefined;

    @JsonProperty('FundAmount', Number, true)
    private _amount: number = undefined;

    @JsonProperty('ExternalTransfer_Trader', StringAdapter, true)
    private _externalTransferTrader: string = undefined;

    constructor() {
        this._id = new Id(uuid.v4());
        this._amount = 0;
    }

    get id(): Id {
        return this._id;
    }

    get externalTransferManager(): string {
        return this._externalTransferManager;
    }

    set externalTransferManager(value: string) {
        this._externalTransferManager = value;
    }

    get externalTransferManagerName(): string {
        return this._externalTransferManagerName;
    }

    set externalTransferManagerName(value: string) {
        this._externalTransferManagerName = value;
    }

    get externalTransferName(): string {
        return this._externalTransferName;
    }

    set externalTransferName(value: string) {
        this._externalTransferName = value;
    }

    get externalTransferISIN(): string {
        return this._externalTransferISIN;
    }

    set externalTransferISIN(value: string) {
        this._externalTransferISIN = value;
    }

    get externalTransferContract(): string {
        return this._externalTransferContract;
    }

    set externalTransferContract(value: string) {
        this._externalTransferContract = value;
    }

    get amount(): number {
        return this._amount;
    }

    set amount(value: number) {
        this._amount = value;
    }

    get externalTransferTrader(): string {
        return this._externalTransferTrader;
    }

    set externalTransferTrader(value: string) {
        this._externalTransferTrader = value;
    }

    isComplete(): boolean {
        return (
            !!this.externalTransferManager &&
            !!this.externalTransferName &&
            !!this.externalTransferISIN &&
            !!this.externalTransferContract &&
            !!this.amount
        );
    }
}
